import { useFetch } from '../lib/useFetch';
import { rideStatusLabels, rideStatusColors, rideTypeLabels, formatFcfa, formatDate } from '../lib/labels';
import { PaginatedResponse } from '@ouagaliv/shared';

interface RowRide {
  id: string;
  type: string;
  status: string;
  pickupAddress: string;
  dropoffAddress: string;
  priceFcfa: number;
  createdAt: string;
  client?: { fullName?: string };
  agent?: { fullName?: string } | null;
}

export default function Rides() {
  const rides = useFetch<PaginatedResponse<RowRide>>('/admin/rides');

  return (
    <div className="page-transition">
      <div className="container pt-6">
        <div className="page-head">
          <div>
            <h1 className="page-title">Courses</h1>
            <p className="page-subtitle">{rides.data ? `${rides.data.total} course(s) au total` : 'Dernières courses de la plateforme'}</p>
          </div>
        </div>

        <div className="card">
          {rides.isLoading ? (
            <div className="state-box"><span className="loading-spinner" /></div>
          ) : rides.error ? (
            <div className="state-box">{rides.error}</div>
          ) : !rides.data?.items.length ? (
            <div className="state-box">Aucune course pour le moment.</div>
          ) : (
            <div className="table-wrap">
              <table className="data-table">
                <thead>
                  <tr><th>Date</th><th>Trajet</th><th>Type</th><th>Client</th><th>Agent</th><th>Prix</th><th>Statut</th></tr>
                </thead>
                <tbody>
                  {rides.data.items.map(r => (
                    <tr key={r.id}>
                      <td style={{ whiteSpace: 'nowrap' }}>{formatDate(r.createdAt)}</td>
                      <td>{r.pickupAddress} → {r.dropoffAddress}</td>
                      <td>{rideTypeLabels[r.type] ?? r.type}</td>
                      <td>{r.client?.fullName ?? '-'}</td>
                      <td>{r.agent?.fullName ?? '-'}</td>
                      <td><strong>{formatFcfa(r.priceFcfa)}</strong></td>
                      <td><span className={`badge ${rideStatusColors[r.status] ?? 'badge-gray'}`}>{rideStatusLabels[r.status] ?? r.status}</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
